/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}banner`;
const observedAttributes = {
    DISMISSED: 'dismissed',
    PERSISTENT: 'persistent',
    CAN_DISMISS: 'can-dismiss',
    THEME: 'theme'
};
const attributes = {
    ...observedAttributes
};
const classes = {
    HAS_ICON: 'has-icon',
    HAS_BUTTON: 'has-button'
};
const selectors = {
    DISMISS_BUTTON: '[part=dismiss-button]',
    ICON_SLOT: 'slot[name=icon]',
    BUTTON_SLOT: 'slot[name=button]'
};
const defaults = {
    THEME: 'info'
};
const events = {
    BEFORE_DISMISS: `${elementName}-before-dismiss`,
    DISMISSED: `${elementName}-dismissed`
};
export const BANNER_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes,
    classes,
    selectors,
    defaults,
    events
};
